export default __webpack_public_path__ + "static/media/Group-7.95c88861.png";